import classNames from 'classnames';
import React from 'react';

import RewindMenu from 'common/components/RewindMenu';
import CopyButton from 'common/components/socialNetworks/CopyButton';
import FacebookShareButton from 'common/components/socialNetworks/FacebookShareButton';
import TwitterShareButton from 'common/components/socialNetworks/TwitterShareButton';
import WhatsAppShareButton from 'common/components/socialNetworks/WhatsAppShareButton';
import { USERSPACE_ROUTES, IS_USERSPACE } from 'common/configuration/constants';
import { displayRewind } from 'common/configuration/rewind';
import { path } from 'common/tools/network/routing';
import trans from 'common/tools/translations/trans';
import { ReduxUser } from 'common/types';

import UserMenuBorderedItem from './UserMenuBorderedItem';

type Props = { user: Partial<ReduxUser> };
const UserMenu = ({ user }: Props) => {
  const userprofileUrl = path(
    'userprofile_index',
    { user: user.account?.id },
    true
  );

  const navLinks = [];

  if (displayRewind(user.account?.id)) {
    navLinks.push(
      <li
        key="rewind-menu-key"
        className={classNames(
          'header-nav-userspace-item',
          'userspace-item-bordered',
          'rewind-menu'
        )}
      >
        <RewindMenu className="header-nav-link" logged={user.loggedIn} />
      </li>
    );
  }

  const filteredRoutes = Object.values(USERSPACE_ROUTES).filter(
    route => route.path !== USERSPACE_ROUTES.settings.path
  );

  navLinks.push(
    filteredRoutes.map((route, index, array) => {
      const key = route.path;
      const classes = classNames('header-nav-userspace-link', 'icon');
      const text = trans(route.label);
      return (
        <li
          key={key}
          className={classNames('header-nav-userspace-item', {
            'userspace-item-bordered': index === array.length - 1
          })}
        >
          <a href={path(route.path, {}, true)} className={classes}>
            {text}
          </a>
        </li>
      );
    })
  );

  navLinks.push(
    <li
      key="settings-public-profile-key"
      className={classNames(
        'header-nav-userspace-item',
        'userspace-item-bordered'
      )}
    >
      <a
        className={classNames('header-nav-userspace-link')}
        href={path(USERSPACE_ROUTES.settings.path)}
      >
        {trans('userspace.menu.settings.title')}
      </a>
      <a
        className={classNames('header-nav-userspace-link')}
        href={userprofileUrl}
      >
        {trans('menu.label.userspace.public_profil')}
      </a>
    </li>
  );

  navLinks.push(
    <UserMenuBorderedItem
      key="disconnect-key"
      className="disconnect"
      icon="icon-deconnexion"
      href={path(
        'signout',
        IS_USERSPACE ? {} : { returnUrl: window.location.href },
        true
      )}
      text={trans('menu.label.mybrand.logoff')}
    />
  );

  navLinks.push(
    <li
      key="share-buttons-key"
      className="header-nav-userspace-item share-buttons"
    >
      <div className="share-buttons-title">
        {trans('userspace.share.my-profile')}
      </div>
      <div className="share-buttons-container">
        <WhatsAppShareButton link={userprofileUrl} size="sm" />
        <FacebookShareButton link={userprofileUrl} size="sm" />
        <TwitterShareButton link={userprofileUrl} size="sm" />
        <CopyButton link={userprofileUrl} size="sm" />
      </div>
    </li>
  );
  return <>{navLinks}</>;
};

export default UserMenu;
